export const COMPONENT_NAME = 'SmartListSlider';

export const sectionMap = {
  artsAndCulture: '7229e126-d45b-46ce-92c7-7af896e03684',
  sports: '9d1c1bd1-fa66-430b-a73a-1655f75601f4',
  familyAndLifestyle: '7d10b98f-9650-4dd5-a79e-7af95e7e565d',
  musicAndNightlife: 'f4677703-5270-48c6-9127-7357a7f89b8d',
}